// file: client/src/offline/chain.js
/**
 * MODULE 09 — outbox HMAC chain (WebCrypto), mirroring the server EXACTLY:
 *   core = id|op_type|offline_ts|sha256hex(JSON.stringify(payload))|prev
 *   hmac = HMAC-SHA256(deviceSecretHex, core) → hex
 * Tamper-EVIDENT, per the plan's honest posture (§4.3).
 */
const enc = new TextEncoder();

const toHex = (buf) =>
  [...new Uint8Array(buf)].map((b) => b.toString(16).padStart(2, "0")).join("");

const fromHex = (hex) =>
  new Uint8Array(hex.match(/.{2}/g).map((h) => parseInt(h, 16)));

export async function sha256Hex(s) {
  return toHex(await crypto.subtle.digest("SHA-256", enc.encode(s)));
}

export async function hmacHex(secretHex, s) {
  const key = await crypto.subtle.importKey(
    "raw",
    fromHex(secretHex),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"],
  );
  return toHex(await crypto.subtle.sign("HMAC", key, enc.encode(s)));
}

export async function signOp(secretHex, op, prev) {
  const payloadHash = await sha256Hex(JSON.stringify(op.payload ?? {}));
  const core = [op.id, op.op_type, op.offline_ts, payloadHash, prev ?? "GENESIS"].join("|");
  return hmacHex(secretHex, core);
}
